<landing-shell-page>
  <landing-header test-id="landing-waterfall">
    <header id="header-to-scroll" class="max-width">
      <span class="mat-body-1">WELCOME TO BLOCKFRAMES</span>
    </header>
  </landing-header>

  <landing-content></landing-content>

</landing-shell-page>
